import React from 'react';

export const Close = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, ref: React.Ref<SVGSVGElement>) => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" ref={ref} {...props}>
        <rect width="24" height="24" />
        <path d="M7 17L16.8995 7.10051" stroke="#FFFFFF" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 7.00001L16.8995 16.8995" stroke="#FFFFFF" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  },
);
